<div style="padding: 24px;">
  <h5 mat-dialog-title class="text-center">{{title}}</h5>

  <div mat-dialog-content *ngIf="!isCountries">
    <ul>
      <li *ngFor="let item of list;">
        {{item.name}}
      </li>
    </ul>
  </div>
  <div mat-dialog-content *ngIf="isCountries">
    <ul>
      <li *ngFor="let item of list;">
        {{item.code}} - {{item.name}}
      </li>
    </ul>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick(false)">Cerrar / Close</button>
  </div>
</div>
